import React, { useState } from "react";
import api from "../api";
import { useNavigate } from "react-router-dom";

export default function ChangePassword() {

  const navigate = useNavigate();

  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");

  const changePassword = async () => {
    setError("");

if (!currentPassword || !newPassword || !confirmPassword) {
  setError("Fill all fields");
  return;
}

if (newPassword.length < 6) {
  setError("New password must be at least 6 characters");
  return;
}

if (newPassword !== confirmPassword) {
  setError("Passwords do not match");
  return;
}

    try {

      setLoading(true);

      await api.put("/account/password", {
        currentPassword,
        newPassword
      });

      alert("Password updated successfully");

      navigate(-1);

    } catch (e) {

      setError(e?.response?.data?.error || "Update failed");

    } finally {
      setLoading(false);
    }

  };

  return (
    <div className="ui-page">

      <h2>Change password</h2>

      <div className="ui-stack mt-20">

        <input
          type="password"
          placeholder="Current password"
          value={currentPassword}
          onChange={(e)=>setCurrentPassword(e.target.value)}
          className="ui-input"
        />

        <input
          type="password"
          placeholder="New password"
          value={newPassword}
          onChange={(e)=>setNewPassword(e.target.value)}
          className="ui-input"
        />
        
        <input
  type="password"
  placeholder="Confirm new password"
  value={confirmPassword}
  onChange={(e)=>setConfirmPassword(e.target.value)}
  className="ui-input"
/>

      </div>
      
      {error && (
  <div className="ui-error mt-10">
    {error}
  </div>
)}

      <button
        className="ui-btn ui-btn-primary mt-20"
        onClick={changePassword}
        disabled={loading}
      >
        {loading ? "Updating..." : "Update password"}
      </button>

    </div>
  );

}